// extracted by mini-css-extract-plugin
export default {"designWrapper":"Design_designWrapper__-mTtN","profilePic":"Design_profilePic__oywbS","badges":"Design_badges__jC-Rp","badge":"Design_badge__JvTZW"};